import { CreateManualSubscriptionRequestBody } from "@syla/shared/types/requests/CreateManualSubscriptionRequest";
import { useMutation } from "react-query";
import { createManualSubscription } from "../api/plans/createManualSubscription";
import { useCurrentAccountStore } from "./currentAccountStore";
import { queryClient } from "./transactionsStore";
import { ACCOUNT_META_QUERY_KEY } from "./useQueryGetAccounts";
import { getSubscriptionQueryKey } from "./useQuerySubscriptions";

export const useMutationCreateManualSubscription = () => {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  return useMutation(
    (props: CreateManualSubscriptionRequestBody) =>
      createManualSubscription(accountId, props),
    {
      mutationKey: [
        ...getSubscriptionQueryKey(accountId),
        "create-manual-subscription",
      ],
      onSuccess: () => {
        queryClient.invalidateQueries(getSubscriptionQueryKey(accountId));
        queryClient.invalidateQueries(ACCOUNT_META_QUERY_KEY);
      },
    },
  );
};
